import NavBar from "./Components/NavBar";
import PhoneNavBar from "./Components/PhoneNavBar";
import Home from "./Pages/Home";
import Footer from "./Components/Footer";
import {Route, Routes} from 'react-router-dom';
import Movies from "./Pages/Movies";
import TvShow from "./Pages/TvShow";
import InTheater from "./Pages/InTheater";
import ComingSoon from "./Pages/ComingSoon";
import Details from "./Pages/Details";
import SideBar from "./Components/SideBar";
import SearchPage from "./Pages/SearchPage";
import Watchlist from "./Pages/Watchlist";
import TrailerPage from "./Pages/TrailerPage";
import Privacy from "./Pages/Privacy";
import { useSelector } from "react-redux";
import Page404 from "./Pages/Page404";

function App() {
  const mode = useSelector(state=>state.ModeReducer);
  return (
    <div className={`relative  ${(mode)?'dark':null}`}>
        <NavBar/>
        <PhoneNavBar/>
        <SideBar/>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/Movies" element={<Movies/>}/>
          <Route path="/Tvshows" element={<TvShow/>}/>
          <Route path="/Intheaters" element={<InTheater/>}/>
          <Route path="/Comingsoon" element={<ComingSoon/>}/>
          <Route path="/Watchlist" element={<Watchlist/>}/>
          <Route path="/Details" element={<Details/>}/>
          <Route path="/Search" element={<SearchPage/>}/>
          <Route path="/Trailer" element={<TrailerPage/>}/>
          <Route path="/Privacy" element={<Privacy/>}/>
          <Route path="*" element={<Page404/>}/>
        </Routes>
        <Footer/>
    </div>
  );
}

export default App;
